/**
 * Native kit tones — the `.ch-native-tone-*` classes in styles/globals.css
 * (native module kit section). Every native card gets its own light tone and
 * neighbours never match, so page code cycles them by index.
 */
export const NATIVE_TONES = [
  "blue", "violet", "green", "amber", "rose", "sky", "teal", "pink", "orange", "indigo",
] as const;

export type NativeTone = (typeof NATIVE_TONES)[number] | "slate";

/** `.ch-native-tone-*` class for position `i` (wraps; negative-safe). */
export function nativeTone(i: number): string {
  const n = NATIVE_TONES.length;
  return `ch-native-tone-${NATIVE_TONES[((i % n) + n) % n]}`;
}

/** Class for a named tone. */
export function nativeToneClass(tone: NativeTone): string {
  return `ch-native-tone-${tone}`;
}
